import React, { useState } from "react";
import { useNavigate, Outlet, useLocation } from "react-router-dom";
import logo from "../assets/img/mjlogo.png";
import API_URL from "../Config";
import { toast } from "react-hot-toast";
import axios from "axios";

const ForgetPasswordAdmin = () => {
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  // Step 1 → Send OTP
  const SendEmail = async () => {
    if (!email) {
      toast.error("Please enter your email");
      return;
    }
    const data = new FormData();
    data.append("email", email);

    try {
      const res = await axios.post(`${API_URL}/api/v2/send-code/forgetpassword`, data, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (res.status === 201) {
        toast.success("OTP sent to your email");
      }
    } catch (error) {
      toast.error(error.response?.data || "Error sending OTP");
    }
  };

  // Step 2 → Verify OTP
  const VerifyCode = async (e) => {
    e.preventDefault();
    if (!code) {
      toast.error("Please enter the OTP");
      return;
    }

    const data = new FormData();
    data.append("email", email);
    data.append("code", code);

    try {
      const res = await axios.post(`${API_URL}/api/v2/verify-code`, data, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (res.status === 200) {
        toast.success(res.data.message);
        navigate("/ResetAdminPassword", { state: { email } }); // pass email to reset page
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Invalid OTP");
    }
  };

  return (
    <>
      {location.pathname === "/adminForgetPassword" ? (
        <div className="w-screen h-screen overflow-hidden flex items-center justify-center bg-gradient-to-b from-black to-blue-950">
          <div className="grid grid-cols-1 md:grid-cols-2 items-center justify-center text-white px-4 sm:px-6 lg:px-12 w-full max-w-6xl scale-105 sm:scale-110 lg:scale-125">
            
            {/* Left: Logo */}
            <div className="hidden md:flex justify-center items-center">
              <img 
                src={logo} 
                alt="Media Jungle" 
                className="w-40 sm:w-64 lg:w-[32rem] object-contain" 
              />
            </div>

            {/* Right: Forget Password Box */}
            <div className="w-full max-w-sm mx-auto">
              {/* Title */}
              <div className="text-center mb-8">
                <h1 className="text-4xl sm:text-5xl lg:text-7xl font-bold text-white">Welcome</h1>
                <p className="text-lg sm:text-xl text-gray-300">
                  <span className="font-bold text-white">Admin</span>
                </p>
              </div>
              <span className="font-bold text-white justify-left">Forget Password?</span>
              <form onSubmit={VerifyCode} className="space-y-4">
                {/* Email */}
                <div className="flex items-center bg-white text-black rounded-lg px-3 py-2">
                  {/* <span className="mr-2">📧</span> */}
                  <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full outline-none bg-transparent h-3"
                    required
                  />
                  <button
                    type="button"
                    onClick={SendEmail}
                    className="ml-2 bg-green-600 hover:bg-green-700 text-white px-3 py-1 rounded-lg text-sm w-[130px] "
                  >
                    Get OTP
                  </button>
                </div>

                {/* OTP */}
                <div className="flex items-center bg-white text-black rounded-lg px-3 py-2">
                  {/* <span className="mr-2">🔑</span> */}
                  <input
                    type="text"
                    name="otp"
                    placeholder="Enter OTP"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    className="w-full outline-none bg-transparent h-6"
                    required
                  />
                </div>

                {/* Submit */}
                <button
                  type="submit"
                  className="w-full bg-red-600 hover:bg-red-700 text-white font-bold py-2 rounded-lg transition"
                  //onClick={()=>navigate("/ResetAdminPassword")}
                >
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      ) : (
        <Outlet />
      )}
    </>
  );
};

export default ForgetPasswordAdmin;